export default "__VITE_ASSET__BeYzNdx9__"